<template>
     <div
        class="box-container relative">
        <div class="text-right w-full absolute right-[16px] top-[7px] z-10">
            <fa
                    :icon="[
                        'fal',
                        'times',
                    ]"
                    class="!text-[20px] !text-gray-300 !font-normal cursor-pointer "  @click="$emit('closeCannedResponse')">
           </fa>
        </div>
        <div class="canned_card_jodit w-full max-h-[200px] overflow-y-auto">
            
       <div class="w-full flex-grow bg-gray-100 flex flex-col rounded relative">
      
        <!-- {{ cannedResponseData.detail_info }} -->
        <jodit_editor v-model='cannedResponseData.detail_info'
        :config="joditConfig"  ref="editorRef"/>
      </div>
    </div>

    <div class="options !mt-0">
        <div class="option-icons gap-2 items-center">
            <slot></slot>
            <fa
              @click="handleFileUpload"
              :icon="['fal', 'paperclip']"
               class="cursor-pointer !text-[20px] !font-[300] !leading-normal"
            ></fa>
            <EmojiDropdown :attachEmoji>
                            <fa
                                :icon="['fal', 'face-smile']"
                                class="cursor-pointer !text-[20px] !font-[300] !leading-normal"
                            ></fa>
           </EmojiDropdown>
        </div>
        <SendButton @click="sendMessage()"/>
    </div>
 </div>
</template>
<script setup>
import { Jodit } from 'jodit-pro/es2021/jodit';
import jodit_editor from '@/components/globals/Jodit/jodit_editor.vue';
import SendButton from '@/components/settings/inbox/inbox-component/SendButton.vue';
import EmojiDropdown from '@/components/settings/inbox/inbox-component/dropdowns/EmojiDropdown.vue';
import {computed, onMounted, ref, watch ,nextTick} from 'vue'
import { useTenantStore } from '@/stores/tenant';
import { uploadFileOnServer } from '@/api/SettingServices.js';
const emits = defineEmits(['sendCannedResponse', 'closeCannedResponse'])
const props = defineProps({
    data :{
        type:Object,
        default:{},
    }
})
 
const cannedResponseData = ref({
    detail_info:''
})
const tenantStore = useTenantStore();
const tenantId = tenantStore.getTenantId;
const editorRef = ref(null)
const Jodit_key = import.meta.env.VITE_APP_JODIT_KEY;
const joditConfig = ref({
    license: Jodit_key,
    zIndex: 0,
    height: 50,
    width: '100%',
    theme: 'default',
    defaultMode: Jodit.MODE_WYSIWYG,
    toolbarInline: true,
    addNewLine: '',
    colorPickerDefaultTab: 'background',
    tabIndex: -1,
    enter: 'P',
    direction: '',
    language: 'auto',
    debugLanguage: false,
    saveModeInCookie: false,
    spellcheck: true,
    editorCssClass: false,
    triggerChangeEvent: true,
    toolbarInlineForSelection: true,
    allowResizeY: false,
    allowResizeX: false,
    toolbar: false,
    uploader: {
        insertImageAsBase64URI: false,
        url: `${import.meta.env.VITE_APP_BASE_URL}/api/v1/timeline/upload-media`,
        // url: 'http://api.voza-local.io/api/v1/timeline/upload-media',
        headers: {
            'X-Tenant': tenantId,
        },
        withCredentials: true,
        isSuccess: function (resp) {
            console.log(resp, 'resp isSuccess')
            return !resp.error;
        },
        process: function (resp) {
            console.log(resp, 'resp pocess')
            return {
                files: resp.data || [],
                path: resp.path,
                baseurl: resp.baseurl,
                error: resp.error,
                msg: resp.msg,
            };
        },
        defaultHandlerSuccess: function (data, resp) {
            console.log(data, resp, 'resp default')
            var i,
                field = 'files';
            if (data[field] && data[field].length) {
                for (i = 0; i < data[field].length; i += 1) {
                    this.s.insertHTML(`<img style="max-width:100%;height:auto" src="${data[field][i]}" alt="image" />`);
                }
            }
        },
        error: function (e) {
            this.message.message(e.getMessage(), 'error', 4000);
        },
        // method: 'POST',
    },
});
const sendMessage =()=>{
emits('sendCannedResponse' , cannedResponseData.value.detail_info)
}
 
const handleFileUpload = () => {
  // Create a file input element
  const fileInput = document.createElement("input");
  fileInput.type = "file";
  fileInput.accept = "image/*,video/*"; // Accept images and videos

  // Trigger file input dialog
  fileInput.click();

  // Handle file selection
  fileInput.onchange = async (event) => {
    const file = event.target.files[0];
    if (file) {
      try {
        // Upload the file using your custom method
        const fileUrl = await uploadFile(file);

        let fileHtml = "";

        // Check file type
        if (file.type.startsWith("image/")) {
          // If file is an image
          fileHtml = `<img src="${fileUrl}" style="max-width:100%; height:auto;">`;
        } else if (file.type.startsWith("video/")) {
          // If file is a video
          fileHtml = `
            <video controls style="max-width:100%; height:auto;">
              <source src="${fileUrl}" type="${file.type}">
              Your browser does not support the video tag.
            </video>
          `;
        } else {
          // For other file types, use a download link
          fileHtml = `<a href="${fileUrl}" target="_blank" class="cursor-pointer  text-blue-600 hover:text-black underline transition-colors">${file.name}</a>`;
        }

        // Insert file into editor
        editorRef.value.setcontent(fileHtml)
      } catch (error) {
        console.error("File upload failed:", error);
      }
    }
  };
};



const uploadFile= async(file)=>{
   try{
       const res = await uploadFileOnServer(file)
       if(res.code==200){ return res.data[0]}
   }catch(e){

   }
}

const attachEmoji = (emoji) => {
    if (emoji) {
        editorRef.value.setcontent(emoji)
    }
};

watch(
    ()=>props.data,
    ()=>{
        cannedResponseData.value.detail_info = props.data.detail_info
})

onMounted( async ()=>{
    cannedResponseData.value.detail_info = props.data.detail_info
})
// watch(
//     ()=>props.data,
//     ()=>{  

//     })

</script>
<style scoped>
.box-container {
    @apply bg-gray-100;
    display: flex;
    padding: 16px;
    flex-direction: column;
    justify-content: flex-end;
    align-items: flex-start;
    gap: -64px;
    align-self: stretch;
    border-radius: 8px;
    /* dropdown dropshadow */
    /* box-shadow: 0px 4px 12px 0px rgba(0, 0, 0, 0.25); */
    width: 100%;
}
.canned_card_jodit :deep(.jodit-container) {
    @apply flex flex-col flex-col-reverse !min-h-full !h-full;
}
.canned_card_jodit :deep(.jodit-container .jodit-workplace) {
    @apply  !min-h-full !h-full;
}

.canned_card_jodit :deep(.jodit-container .jodit-workplace > div:first-child) {
    @apply  !min-h-full !h-full  !bg-gray-100;;
}

.canned_card_jodit :deep(.jodit-container .jodit-toolbar__box:not(:empty)) {
    @apply !overflow-visible;
}

.canned_card_jodit :deep(.jodit-container .jodit-status-bar + div[role='button']) {
    display: none;
}

.canned_card_jodit :deep(.jodit-emoji__emoji) {
    @apply inline-block m-2;
}

.jodit-container.jodit.jodit_theme_default.jodit-wysiwyg_mode {
    @apply border-0;
}
.options {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    @apply mt-auto;
}

.mode > svg {
    color: #c5c7d1;
    font-family: 'Font Awesome 6 Pro';
    font-size: 24px;
    font-style: normal;
    font-weight: 300;
    line-height: normal;
}
.option-icons {
    color: var(--Gray-text, #bac4cd);
    font-family: 'Font Awesome 6 Pro';
    font-size: 24px;
    font-style: normal;
    font-weight: 400;
    line-height: 0;
    position: relative;
    display: flex;
    height: 20.5px;
}
</style>
<style>
.canned_card_jodit  * {
    background: transparent !important;
}
</style>